function c(i, t, s) {
  const e = i.prerender;
  i.prerender = function(...n) {
    s.value.apply(this, n), e.apply(this, n);
  };
}
function d(i, t, s) {
  const e = i.postrender;
  i.postrender = function(...n) {
    s.value.apply(this, n), e.apply(this, n);
  };
}
function f(i, t, s) {
  const e = i.destroy;
  i.destroy = function(...n) {
    s.value.apply(this, n), e.apply(this, n);
  };
}
const h = (i) => (t) => {
  t.mixins && Array.isArray(t.mixins) && (t.mixins = [...t.mixins, i]);
};
function w(i, t) {
  const s = {
    waitUntilFirstUpdate: !1,
    ...t
  };
  return (e, n) => {
    const { update: l } = e, y = Array.isArray(i) ? i : [i];
    e.update = function(o) {
      y.forEach((u) => {
        const a = u;
        if (o.has(a)) {
          const p = o.get(a), r = this[a];
          p !== r && (!s.waitUntilFirstUpdate || this.hasUpdated) && this[n](
            p,
            r
          );
        }
      }), l.call(this, o);
    };
  };
}
export {
  d as a,
  f as d,
  h as m,
  c as p,
  w
};
